<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>Create Message Group</p>
      <i id="msgGroupClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="m-0">
  <mat-accordion>
      <mat-expansion-panel [expanded]="panelOpenState">
          <form [formGroup]="messageGroupForm">
              <div class="row back-row">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                      <mat-form-field style="width: 100%;">
                          <mat-label>New Message Group </mat-label>
                          <input matInput formControlName="formMGList" (change)="filterGroupList($event)">
                      </mat-form-field>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                      <EIPAutoComplete ShowTextValueField='N' setId="mgList" formControlName="formMGListList" TextField="groupDescription"  ValueField="groupId" WaterMarkText="Message Group" [IsCascading]='true' [dataSource]='mgList' (valueChange)='onMGValueChange($event,"formMGList")'>
                      </EIPAutoComplete>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                      <EIPAutoComplete style="width: 270px;" ShowTextValueField='N' formControlName="business_GroupId" WaterMarkText="Business Group" TextField="group_Name" ValueField="group_Id" [dataSource]='businessGroupList' setId="ddMrlBusGrpId" (valueChange)='changeBusinessGroup($event)' [IsCascading]='true'>
                      </EIPAutoComplete>
                  </div>
              </div>
              <div class="row back-row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <mat-form-field style="width: 100%;">
                          <mat-label>To *</mat-label>
                          <mat-chip-list #toChipList formControlName="toMembers">
                              <ng-container *ngFor="let member of toMembers">
                                  <mat-chip color="primary" [selectable]="selectable" [removable]="removable" (removed)="removeTo(member)">
                                      {{member.memberName}}
                                      <i matChipRemove class="fa fa-times-circle" title="Close" aria-hidden="true"></i>
                                  </mat-chip>
                              </ng-container>
                              <input #toInput (focus)="matToAutoComplete.showPanel = true" formControlName="toMembersCtrl" [matAutocomplete]="toauto" [matChipInputFor]="toChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur">
                          </mat-chip-list>
                          <mat-autocomplete #toauto="matAutocomplete">
                              <mat-option *ngFor="let member of toFilteredMembers | async" [value]="member">
                                  <div (click)="optionClicked($event, member,'to')">
                                      <mat-checkbox [checked]="isMemberSelected(member,'to')" (change)="toggleToSelection(member)" (click)="$event.stopPropagation()">
                                          {{member.memberName}}
                                      </mat-checkbox>
                                  </div>
                              </mat-option>
                          </mat-autocomplete>
                      </mat-form-field>
                  </div>
              </div>
              <div class="row back-row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <mat-form-field style="width: 100%;">
                          <mat-label>Cc</mat-label>
                          <mat-chip-list #ccChipList formControlName="ccMembers">
                              <ng-container *ngFor="let member of ccMembers">
                                  <mat-chip color="primary" [selectable]="selectable" [removable]="removable" (removed)="removeCc(member)">
                                      {{member.memberName}}
                                      <i matChipRemove class="fa fa-times-circle" title="Close" aria-hidden="true"></i>
                                  </mat-chip>
                              </ng-container>
                              <input #ccInput (focus)="matCcAutoComplete.showPanel = true" formControlName="ccMembersCtrl" [matAutocomplete]="ccauto" [matChipInputFor]="ccChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur">
                          </mat-chip-list>
                          <mat-autocomplete #ccauto="matAutocomplete">
                              <mat-option *ngFor="let member of ccFilteredMembers | async" [value]="member">
                                  <div (click)="optionClicked($event, member,'cc')">
                                      <mat-checkbox [checked]="isMemberSelected(member,'cc')" (change)="toggleCcSelection(member)" (click)="$event.stopPropagation()">
                                          {{member.memberName}}
                                      </mat-checkbox>
                                  </div>
                              </mat-option>
                          </mat-autocomplete>
                      </mat-form-field>
                  </div>
              </div>
              <div class="row back-row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <mat-form-field style="width: 100%;">
                          <mat-label>Bcc</mat-label>
                          <mat-chip-list #bccChipList formControlName="bccMembers">
                              <ng-container *ngFor="let member of bccMembers">
                                  <mat-chip color="primary" [selectable]="selectable" [removable]="removable" (removed)="removebcc(member)">
                                      {{member.memberName}}
                                      <i matChipRemove class="fa fa-times-circle" title="Close" aria-hidden="true"></i>
                                  </mat-chip>
                              </ng-container>
                              <input #bccInput (focus)="matbccAutoComplete.showPanel = true" formControlName="bccMembersCtrl" [matAutocomplete]="bccauto" [matChipInputFor]="bccChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur">
                          </mat-chip-list>
                          <mat-autocomplete #bccauto="matAutocomplete">
                              <mat-option *ngFor="let member of bccFilteredMembers | async" [value]="member">
                                  <div (click)="optionClicked($event, member,'bcc')">
                                      <mat-checkbox [checked]="isMemberSelected(member,'bcc')" (change)="togglebccSelection(member)" (click)="$event.stopPropagation()">
                                          {{member.memberName}}
                                      </mat-checkbox>
                                  </div>
                              </mat-option>
                          </mat-autocomplete>
                      </mat-form-field>
                  </div>
              </div>
          </form>
      </mat-expansion-panel>
  </mat-accordion>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button class="btn btn-primary" id="btnSave" *ngIf="showBtn" (click)="saveMessageGroup()"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>
      <button class="btn btn-primary" id="btnSave" *ngIf="showBtn == false" (click)="saveMessageGroup()"><i class="fa fa-re-edit" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Update</button>
      <button class="btn btn-secondary" id="btnCancel" (click)="closeDialog()"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
  </div>
</div>